import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }


  SaveAuthor(strdata: any): Observable<any> {
    let param = 'objAuthor=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveAuthor?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllAuthor(): Observable<any> {
    
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllAuthor', { headers: reqHeader });
  }

  AuthorMarkActive(data: any): Observable<any> {
    
    let param = 'objAuthor=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/AuthorMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  // book status 

  SaveBookStatus( booklist:any): Observable<any> {
    let formData = new FormData();    
    formData.append("objList", booklist);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookStatus', formData);
  }


  GetALLBookAcc(strdata: any): Observable<any> {
    let param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetALLBookAcc?' + encodeURI(param), { headers: reqHeader });
  }

  // book master

  SaveBookMST(data, lst): Observable<any> {    

    let param = 'objBook=' + data + '&lst=' + lst;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookMST?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllBookMST(strdata: any): Observable<any> {
    let param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllBookMST?' + encodeURI(param), { headers: reqHeader });
  }

  SaveBook(strdata: any): Observable<any> {
    let param = 'objBook=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBook?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllBook(strdata: any): Observable<any> {
    let param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllBook?' + encodeURI(param), { headers: reqHeader });
  }

  UploadBook(strdata): Observable<any> {
    let formData = new FormData();
    formData.append("strdata", strdata); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/UploadBook', formData);
  }
  BookMarkActive(strdata: any): Observable<any> {
    let param = 'objBook=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/BookMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllEddition(): Observable<any> {
    
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllEddition', { headers: reqHeader });
  }

  SaveEddition(strdata: any): Observable<any> {
    let param = 'objBookEdditionMST=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveEddition?' + encodeURI(param), { headers: reqHeader });
  }

  
  BookEditionMarkActive(strdata: any): Observable<any> {
    let param = 'objBookEdditionMST=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/BookEditionMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

   // Book Fine Collection

   GetBookFineCollection(strdata: any): Observable<any> {
    let param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetBookFineCollection?' + encodeURI(param), { headers: reqHeader });
  }

  GetFineDetails(strdata: any): Observable<any> {
    let param = 'BookFineID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetFineDetails?' + encodeURI(param), { headers: reqHeader });
  }

  SaveBookGroup(strdata: any): Observable<any> {
    let param = 'objGroup=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookGroup?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllBookGroup(): Observable<any> {
    
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllBookGroup', { headers: reqHeader });
  }

  SaveBookReservation(strdata: any): Observable<any> {
    let param = 'ObjLib=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookReservation?' + encodeURI(param), { headers: reqHeader });
  }

  BookGroupMarkActive(strdata: any): Observable<any> {
    let param = 'objGroup=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/BookGroupMarkActive?' + encodeURI(param), { headers: reqHeader });
  }

  GetBookISBN(strdata: any): Observable<any> {
    let param = 'objFilter=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetBookISBN?' + encodeURI(param), { headers: reqHeader });
  }

    // Book Issues

    GetAllIssueDetails(strdata: any): Observable<any> {
      let param = 'LibCardNo=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllIssueDetails?' + encodeURI(param), { headers: reqHeader });
    }
    SearchPersonDetails(strdata: any): Observable<any> {
      let param = 'LibCardNo=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SearchPersonDetails?' + encodeURI(param), { headers: reqHeader });
    }
    
  
    SearchBookIssue(BookSerialNo, LibCardNo): Observable<any> {
 
      let param = 'BookSerialNo=' + BookSerialNo + '&LibCardNo=' + LibCardNo;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SearchBookIssue?' + encodeURI(param), { headers: reqHeader });
    }
    
    SaveBookReturn(objReturn, booklist): Observable<any> {
      let formData = new FormData();
      formData.append("objReturn", objReturn);
      formData.append("booklist", booklist);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookReturn', formData);
    }

    SaveBookRenew(objReturn, booklist): Observable<any> {
      let formData = new FormData();
      formData.append("objReturn", objReturn);
      formData.append("booklist", booklist);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookRenew', formData);
    }

    // Books Issue Report
  
    SearchBookslostReport(strdata: any): Observable<any> {
      let param = 'ObjModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SearchBookslostReport?' + encodeURI(param), { headers: reqHeader });
    }
    
    // Books Stock Report
 
    GetBookStockReport(strdata: any): Observable<any> {
      let param = 'objFilter=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetBookStockReport?' + encodeURI(param), { headers: reqHeader });
    }

    ReturnBookIssue(objReturn, booklist): Observable<any> {
      let formData = new FormData();
      formData.append("objReturn", objReturn);
      formData.append("booklist", booklist);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/ReturnBookIssue', formData);
    }

    SaveBookPurchaseEntry(data, prm): Observable<any> {
      let formData = new FormData();
      formData.append("objEntry", data);
      formData.append("objList", prm);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookPurchaseEntry', formData);
    }

    GetAllBookPurchaseEntry(): Observable<any> {
    
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllBookPurchaseEntry', { headers: reqHeader });
    }

    GetAllVendor(): Observable<any> {
    
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllVendor', { headers: reqHeader });
    }

    GetLibraryPurchaseList(strdata: any): Observable<any> {
      let param = 'LibraryModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetLibraryPurchaseList?' + encodeURI(param), { headers: reqHeader });
    }

    
    SearchBooksReceivedReport(strdata: any): Observable<any> {
      let param = 'ObjModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SearchBooksReceivedReport?' + encodeURI(param), { headers: reqHeader });
    }

    SaveBookTitle(data: any): Observable<any> {   
      let param = 'objBookTitleMST=' + data;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookTitle?' + encodeURI(param), { headers: reqHeader });
    }
    SaveBookType(strdata: any): Observable<any> {
      let param = 'objBookTypeMST=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookType?' + encodeURI(param), { headers: reqHeader });
    }

    BookTypeMarkActive(strdata: any): Observable<any> {
      let param = 'objBookTypeMST=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/BookTypeMarkActive?' + encodeURI(param), { headers: reqHeader });
    }

    GetAllBookType(): Observable<any> {
    
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllBookType', { headers: reqHeader });
    }

    GetGenerateLibraryCardNoStudent(strdata: any): Observable<any> {
      let param = 'objFilter=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetGenerateLibraryCardNoStudent?' + encodeURI(param), { headers: reqHeader });
    }

    SaveGenerateLibraryCardNoStudent(ObjStudent, objList): Observable<any> {
      let formData = new FormData();
      formData.append("ObjStudent", ObjStudent);
      formData.append("objList", objList);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveGenerateLibraryCardNoStudent', formData);
    }

    GetGenerateLibraryCardNoStaff(strdata: any): Observable<any> {
      let param = 'objFilter=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetGenerateLibraryCardNoStaff?' + encodeURI(param), { headers: reqHeader });
    }

    SaveGenerateLibraryCardNoStaff(ObjStaff, objList): Observable<any> {
      let formData = new FormData();
      formData.append("ObjStaff", ObjStaff);
      formData.append("objList", objList);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveGenerateLibraryCardNoStaff', formData);
    }

    GetLibraryConfiguation(): Observable<any> {
    
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetLibraryConfiguation' , { headers: reqHeader });
    }


    SaveLibraryConfiguation(strdata: any): Observable<any> {
      let param = 'ObjLib=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveLibraryConfiguation?' + encodeURI(param), { headers: reqHeader });
    }


    SaveLibraryType(strdata: any): Observable<any> {
      let param = 'objLibrary=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveLibraryType?' + encodeURI(param), { headers: reqHeader });
    }

    LibraryTypeMarkActive(strdata: any): Observable<any> {
      let param = 'objLibrary=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/LibraryTypeMarkActive?' + encodeURI(param), { headers: reqHeader });
    }

    
    GetAllLibraryType(): Observable<any> {
    
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllLibraryType', { headers: reqHeader });
    }

    SavePublication(strdata: any): Observable<any> {
   
      let param = 'objPublication=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SavePublication?' + encodeURI(param), { headers: reqHeader });
    }

    GetAllPublication(strdata: any): Observable<any> {
      let param = 'objFilter=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllPublication?' + encodeURI(param), { headers: reqHeader });
    }

    PublicationMarkActive(strdata: any): Observable<any> {
  
      let param = 'objPublication=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/PublicationMarkActive?' + encodeURI(param), { headers: reqHeader });
    }

    SaveBookIssue(objIssue, booklist): Observable<any> {
      let formData = new FormData();
      formData.append("objIssue", objIssue);
      formData.append("booklist", booklist);
  
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookIssue', formData);
    }

    SaveBookUnreserved(strdata: any): Observable<any> {
      alert('dmd')
      let param = 'ObjLib=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SaveBookUnreserved?' + encodeURI(param), { headers: reqHeader });
    }

    GetCancelBookFine(ReceiptNo, CancelRemarks): Observable<any> {
 
      let param = 'ReceiptNo=' + ReceiptNo + '&CancelRemarks=' + CancelRemarks;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetCancelBookFine?' + encodeURI(param), { headers: reqHeader });
    }

    BookTitleMarkActive(data: any): Observable<any> {
  
      let param = 'objBookTitleMST=' + data;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/BookTitleMarkActive?' + encodeURI(param), { headers: reqHeader });
    }

    GetAllBookTitle(strdata: any): Observable<any> {
      let param = 'objFilter=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/GetAllBookTitle?' + encodeURI(param), { headers: reqHeader });
    }

    SerchBooksIssueReturnDetail(strdata: any): Observable<any> {
     
      let param = 'ObjModel=' + strdata;
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Library/SerchBooksIssueReturnDetail?' + encodeURI(param), { headers: reqHeader });
    }
   
   
}
